import React from 'react';
import { Truck, MessageSquare, Route, Navigation } from 'lucide-react';

const FeaturesGrid = () => {
  const features = [
    {
      icon: <Truck className="w-8 h-8" />,
      title: 'Smart Load Matching',
      description: 'automated load routing and optimization'
    },
    {
      icon: <Navigation className="w-8 h-8" />,
      title: 'Real-Time Dispatch',
      description: 'timing and dispatching loads in real time'
    },
    {
      icon: <MessageSquare className="w-8 h-8" />,
      title: 'Fleet Communication',
      description: 'communicate with drivers in real-time'
    },
    {
      icon: <Route className="w-8 h-8" />,
      title: 'Route Optimization',
      description: 'optimize, identify, planning, or analyze'
    }
  ];

  return (
    <section className="py-12 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-purple-600 to-purple-500 p-8 rounded-2xl text-white hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
            >
              <div className="mb-4 text-white">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
              <p className="text-purple-100 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
